import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface newFileState {
    isClicked: boolean;
  }
  
  const initialState: newFileState = {
    isClicked: false,
  };
  
  const buttonSlice = createSlice({
    name: "newFile",
    initialState,
    reducers: {
      setClicked: (state) => {
        state.isClicked = true;
      },
      setClickedFalse: (state)=>{
        state.isClicked=false;
      }
    },
  });
  
  export const { setClicked, setClickedFalse } = buttonSlice.actions;
  export default buttonSlice.reducer;

